import MembMktgAgreInqApi from "Apis/MembMktgAgreInqApi";
import MembMktgAgreChngApi from "Apis/MembMktgAgreChngApi";
import { ChangeEvent, KeyboardEvent, useEffect, useLayoutEffect, useRef, useState } from "react";
import MgpStore from "Stores/Store";
import ApiError from "Utils/ApiError";
import ApiResultModal from "Components/ApiResultModal";
import { useSelector } from "react-redux";



const MembMktgAgreUi = ({langData}:any) => {
    const [membAccnDtlInfo,setMembAccnDtlInfo] = useState();
    const [emlNtfyRecvYn,setEmlNtfyRecvYn] = useState("N");
    const [smsNtfyRecvYn,setSmsNtfyRecvYn] = useState("N");
    const [emlNtfyRecvYnDraft, setEmlNtfyRecvYnDraft] = useState("N");
    const [smsNtfyRecvYnDraft, setSmsNtfyRecvYnDraft] = useState("N");
    const [emlNtfyChngDtime, setEmlNtfyChngDtime] = useState<string | null>(null);
    const [smsNtfyChngDtime, setSmsNtfyChngDtime] = useState<string | null>(null);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const loginInfo = useSelector((state: any) => state.LoginInfoState?.LoginInfo?.apiBody);
    const emlLabelRef = useRef<HTMLLabelElement | null>(null);
    const smsLabelRef = useRef<HTMLLabelElement | null>(null);
    const [labelWidth, setLabelWidth] = useState<number | null>(null);

    const isMbp = MgpStore.getState().IdntMthdCdState.IdntMthdCd === "MBP";

    useLayoutEffect(() => {
        const getNaturalLabelWidth = (el: HTMLLabelElement | null) => {
            if (!el) return 0;
            const prevWidth = el.style.width;
            el.style.width = "auto";
            const measuredWidth = Math.ceil(el.getBoundingClientRect().width);
            el.style.width = prevWidth;
            return measuredWidth;
        };

        const resizeLabelWidth = () => {
            const emlWidth = getNaturalLabelWidth(emlLabelRef.current);
            const smsWidth = getNaturalLabelWidth(smsLabelRef.current);
            const nextWidth = Math.max(emlWidth, smsWidth);
            setLabelWidth(nextWidth >= 60 ? nextWidth : null);
        };

        resizeLabelWidth();
        window.addEventListener("resize", resizeLabelWidth);

        return () => {
            window.removeEventListener("resize", resizeLabelWidth);
        };
    }, [langData?.MYPAGE_MAIN_EML_NTFY_LBL_00, langData?.MYPAGE_MAIN_SMS_NTFY_LBL_00, loginInfo?.emlYn, isMbp]);

    const hasValidDtime = (value: string | null) => {
        if (value == null) return false;
        const normalized = String(value).trim().toLowerCase();
        return normalized !== "" && normalized !== "null";
    };

    const getText = (key: string, fallback: string) => langData?.[key] ?? fallback;

    const applyTemplate = (template: string, values: Record<string, string>) => {
        let result = template;
        Object.entries(values).forEach(([token, value]) => {
            result = result.split(`{${token}}`).join(value);
        });
        return result;
    };

    const renderRecvStatus = (yn: string) => {
        const isAgree = yn === "Y";
        return (
            <span className={isAgree ? "mktgRecvAgree" : "mktgRecvDisagree"}>
                {isAgree
                    ? getText("COMM_MAIN_AGREE_TXT_00", "동의")
                    : getText("COMM_MAIN_DISAGREE_TXT_00", "비동의")}
            </span>
        );
    };

    const renderRecvMsg = (dtime: string | null, channelKey: string, channelFallback: string, yn: string) => {
        if (!hasValidDtime(dtime)) return "";

        const messageTemplate = getText(
            "MYPAGE_MAIN_MKTG_RECV_STTS_CHNG_MSG_00",
            "{date} {channel} 수신 상태를 [{status}]로 변경하셨습니다."
        );
        const messageWithoutStatus = applyTemplate(messageTemplate, {
            date: dtime ?? "",
            channel: getText(channelKey, channelFallback),
            status: "{status}"
        });
        const [beforeStatus, ...afterStatusParts] = messageWithoutStatus.split("{status}");

        if (afterStatusParts.length === 0) {
            return messageWithoutStatus;
        }

        return (
            <>
                {beforeStatus}
                {renderRecvStatus(yn)}
                {afterStatusParts.join("{status}")}
            </>
        );
    };

    const toggleDraftYn = (value: string) => (value === "Y" ? "N" : "Y");

    const onToggleByKeyboard = (e: KeyboardEvent<HTMLSpanElement>, toggleFunc: () => void) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggleFunc();
        }
    };

    const openResultModal = (message: string) => {
        setResultModalMessage(message);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
    };

    const applyMktgAgreState = (apiBody: any) => {
        const nextEmlYn = apiBody?.emlNtfyRecvYn ?? "N";
        const nextSmsYn = apiBody?.smsNtfyRecvYn ?? "N";
        setEmlNtfyRecvYn(nextEmlYn);
        setSmsNtfyRecvYn(nextSmsYn);
        setEmlNtfyRecvYnDraft(nextEmlYn);
        setSmsNtfyRecvYnDraft(nextSmsYn);
        setEmlNtfyChngDtime(apiBody?.emlNtfyChngDtime ?? null);
        setSmsNtfyChngDtime(apiBody?.smsNtfyChngDtime ?? null);
    };

    const loadMktgAgreInfo = () => {
        MembMktgAgreInqApi()
        .then((resp) => {
            applyMktgAgreState(resp.apiBody);
        });
    };

    useEffect(()=>{
        loadMktgAgreInfo();
    },[MgpStore.getState().LangSetState]);
    const AgreEmlNtfyFunc = (e:ChangeEvent<HTMLInputElement>) => {

            if(e.target.checked) {
                setEmlNtfyRecvYnDraft("Y");
            }else {
                setEmlNtfyRecvYnDraft("N");
            }

    }
    const AgreSmsNtfyFunc = (e:ChangeEvent<HTMLInputElement>) => {
        if(e.target.checked) {
            setSmsNtfyRecvYnDraft("Y");
        }else {
            setSmsNtfyRecvYnDraft("N");
        }
    }
    const MembMktgAgreChngFunc =() => {
        MembMktgAgreChngApi(emlNtfyRecvYnDraft,smsNtfyRecvYnDraft)
        .then((Resp) => {
            switch(Resp.apiHdr.code){
                case "MEMB0000":
                    applyMktgAgreState(Resp.apiBody);
                    openResultModal(langData&&langData.MYPAGE_MAIN_MKTG_CHNG_RSULT_DESC_00);
                    //마케팅 수신 동의가 변경되었습니다.
                    break;
                default:
                    ApiError(langData,Resp.apiHdr.code);
                    return;
            }
        });
    }

    return(
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
        />
        <div className="myPageCard MktgCard">
            <h2>Marketing Consent</h2>
            <div className="dFlex MktgCardCtxtWrap">
                <div className="myPageCardCtxt MktgCardCtxt">
                    <div className="mktgAgreeRows">
                        {loginInfo&&loginInfo.emlYn === "Y"?
                            <div className="mktgAgreeRow">
                                <input type="checkbox" name='agreEmlNtfy' className='agreChkBox' id='agreEmlNtfy' checked={emlNtfyRecvYnDraft=="Y"} onChange={AgreEmlNtfyFunc}/>
                                <label ref={emlLabelRef} className="mktgAgreeLabel" style={{ width: labelWidth ? `${labelWidth}px` : undefined }} htmlFor="agreEmlNtfy">
                                    {langData&&langData.MYPAGE_MAIN_EML_NTFY_LBL_00}
                                    {/* 이메일 알림 수신 동의 */}
                                </label>
                                <span className="mktgAgreeMsg">
                                    {hasValidDtime(emlNtfyChngDtime)
                                        ? <span
                                            className="mktgAgreeMsgToggle"
                                            role="button"
                                            tabIndex={0}
                                            onClick={() => setEmlNtfyRecvYnDraft(toggleDraftYn(emlNtfyRecvYnDraft))}
                                            onKeyDown={(e) => onToggleByKeyboard(e, () => setEmlNtfyRecvYnDraft(toggleDraftYn(emlNtfyRecvYnDraft)))}
                                        >
                                            {renderRecvMsg(emlNtfyChngDtime, "COMM_MAIN_EMAIL_CHNL_TXT_00", "이메일", emlNtfyRecvYn)}
                                        </span>
                                        : ""}
                                </span>
                            </div>:
                            <></>
                        }
                        {isMbp?
                            <div className="mktgAgreeRow">
                                <input type="checkbox" name='agreSmsNtfy' className='agreChkBox' id='agreSmsNtfy' checked={smsNtfyRecvYnDraft=="Y"} onChange={AgreSmsNtfyFunc}/>
                                <label ref={smsLabelRef} className="mktgAgreeLabel" style={{ width: labelWidth ? `${labelWidth}px` : undefined }} htmlFor="agreSmsNtfy">
                                    {langData&&langData.MYPAGE_MAIN_SMS_NTFY_LBL_00}
                                    {/* SMS 알림 수신 동의 */}
                                </label>
                                <span className="mktgAgreeMsg">
                                    {hasValidDtime(smsNtfyChngDtime)
                                        ? <span
                                            className="mktgAgreeMsgToggle"
                                            role="button"
                                            tabIndex={0}
                                            onClick={() => setSmsNtfyRecvYnDraft(toggleDraftYn(smsNtfyRecvYnDraft))}
                                            onKeyDown={(e) => onToggleByKeyboard(e, () => setSmsNtfyRecvYnDraft(toggleDraftYn(smsNtfyRecvYnDraft)))}
                                        >
                                            {renderRecvMsg(smsNtfyChngDtime, "COMM_MAIN_SMS_CHNL_TXT_00", "SMS", smsNtfyRecvYn)}
                                        </span>
                                        : ""}
                                </span>
                            </div>
                        
                        :<></>}
                    </div>
                </div>
                <div className="ntfyChngBtnWrap">
                    <button onClick={()=> MembMktgAgreChngFunc()}>
                        <p>{langData&&langData.MYPAGE_MAIN_MKTG_CHNG_BTN_00}</p>
                        {/* 변경하기 */}
                    </button>
                </div>

            </div>
        </div>
        </>
    )
}

export default MembMktgAgreUi;